import styled from 'styled-components';

export const ContributionPicker = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  bottom: 7px;
  top: auto;
  right: 28px;
`;

export const ContributionButton = styled.button`
  padding: 0 12px;
  height: 32px;
  line-height: 32px;
  background: ${props => (props.active ? '#0078D4' : '#FFF')};
  color: ${props => (props.active ? '#FFF' : '#757575')};
  transition: all 0.2s ease;
  text-shadow: none;

  &:first-of-type {
    border-radius: 50% 0 0 50%;
  }

  &:last-of-type {
    border-radius: 0 50% 50% 0;
  }

  &:focus {
    text-shadow: inherit !important;
    background: ${props => (props.active ? '#0078D4' : '#FAFAFA')} !important;
  }

  &:hover {
    text-shadow: inherit !important;
    background: ${props => (props.active ? '#417ec6' : '#E7E7E7')} !important;
  }
`;
